import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";

//Redux
// import { useSelector} from "react-redux";
import DataTable from "react-data-table-component";
import SupplierConstants from "../../../../common/SupplierConstants";

//Serivce
// import ItemService from "../../../../services/customer_appCommonService";
import { useDispatch, useSelector } from "react-redux";
import { getMaterialListv2 } from "../../../../redux/feature/customer_app/customerSlice";
// import { SearchField } from "../../../../Components/formElements/SearchField";

const MaterialSelectionModal = React.forwardRef((props, ref) => {
  const [disabled, setDisabled] = useState(true);
  // eslint-disable-next-line
  const [data, setData] = useState([]);
  // eslint-disable-next-line
  const [loading, setLoading] = useState(false);
  const [isCardVisible, setCardVisible] = useState(true);
  const [getSelectedData, setSelectedData] = useState([]);
  // eslint-disable-next-line
  const [filteredData, setFilteredData] = useState([]);
  // eslint-disable-next-line
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const searchableKeys = [
    "materialCode",
    "materialLongText",
    "materialType",
    "materialGroupLongText",
    "materialClass2",
    "materialClass",
    "material",
    "uOM",
    "plant",
    "materialGroup",
    "materialDescription",
    "cgst",
    "gst",
    "hsn_sac",
    "reversePercentage",
    "perBagBox",
    "sgst",
    "reversePercentage",
    "unitIn",
    "activeInactive",
  ];

  const dispatch = useDispatch();

  let materialData = useSelector((state) => state?.customer?.material?.data);

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  const handleChangeCat = ({ selectedRows }) => {
    const updatedSelectedRows = selectedRows.map((row) => ({
      ...row,
      accOnOff: true, // default value added
      isShippingEdited: false,
      isPostalEdited: false,
      loadingTruckNo: "",
    }));

    setSelectedData(updatedSelectedRows);

    if (selectedRows.length > 0) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  // const loadGetMaterials = async () => {
  //   let obj = {};
  //   await ItemService.getMaterials(obj).then((item) => {
  //     setData(item.data);
  //   });
  // };
  const loadGetMaterials = async () => {
    let obj = {
      queryName: "Get_ALL_Materials",
      page: 1,
      per_page: 10,
      rowFilter: {
        $and: [{ materialType: "POC" }, { activeInactive: true }],
      },
    };

    dispatch(getMaterialListv2(obj));
    // await ItemService.getMaterials(obj).then((item) => {
    //   // const filtered = item.data?.filter(
    //   //   (m) => m.hasOwnProperty("activeInactive") && m.activeInactive === true,
    //   // );

    //   setData(item.data);
    // });
  };

  useEffect(() => {
    // setData(categorySelectionData)
    loadGetMaterials();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Handle Submit IviteTeamMembers
  const handleSubmit = async () => {
    props.onselectedcatdata(getSelectedData);
    props.onHide();
  };

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  // const columns = [
  //   {
  //     name: "Material",
  //     selector: (row) => row?.materialDescription,
  //     cell: (row) => (
  //       <div>
  //         <p className="m-0 p-0  fw-bold text-primary">
  //           {row?.materialDescription}{" "}
  //         </p>
  //         <p className="m-0 p-0 pt-1  ">{row?.materialCode} </p>
  //       </div>
  //     ),
  //     sortable: true,
  //     width: "200px",
  //   },

  //   {
  //     name: "UOM",
  //     selector: (row) => row.uOM || "--",
  //     sortable: true,
  //     width: "100px",
  //   },
  //   {
  //     name: "Per Bag/Box",
  //     selector: (row) => row.perBagBox || "--",
  //     cell: (row) => (
  //       <div>
  //         <p className="m-0 p-0  fw-bold text-primary">{row?.perBagBox} </p>
  //         <p className="m-0 p-0 pt-1  ">{row?.unitIn} </p>
  //       </div>
  //     ),
  //     sortable: true,
  //     width: "130px",
  //   },
  //   {
  //     name: "CGST%",
  //     selector: (row) => row.cgst || "--",
  //     sortable: true,
  //     width: "100px",
  //   },
  //   {
  //     name: "SGST%",
  //     selector: (row) => row.sgst || "--",
  //     sortable: true,
  //     width: "100px",
  //   },
  //     {
  //     name: "Active",
  //     selector: (row) => row.activeInactive,
  //     cell: (row) => (
  //       <div className="form-check form-switch">
  //         <input
  //           className="form-check-input custom-switch"
  //           type="checkbox"
  //           role="switch"
  //           id={`switch-${row.local_id}`}
  //           checked={row.activeInactive === true}
  //           // onChange={(event) => handleCheckboxChange(row.local_id, event)}
  //         />
  //       </div>
  //     ),
  //     sortable: true,
  //     width: "130px",
  //   },
  //   // {
  //   //   name: "Category",
  //   //   selector: (row) => row.materialGroup || "--",
  //   //   sortable: true,
  //   //   width: "130px",
  //   // },
  //   // {
  //   //   name: "Dealers",
  //   //   selector: (row) => row.plant || "--",
  //   //   sortable: true,
  //   //   width: "200px",
  //   // },
  // ];

  //serch fucntion
  const columns = [
    {
      name: "Material",
      id: "materialDescription",
      selector: (row) => row.productName || "--",
      cell: (row) => (
        <div
          className="flex justify-center items-center cursor-pointer"
          // onClick={() => showAddProduct("DETAILS", row.documentNumber, row)}
        >
          <div className="ms-2">
            <p className="m-0 p-0 pt-1 fw-bold">{row?.materialCode} </p>

            <p className="m-0 p-0 pt-1 fw-bold text-success">
              {row.materialDescription}{" "}
            </p>
          </div>
        </div>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "UOM",
      selector: (row) => row?.uOM || "--",
      sortable: true,
      width: "100px",
    },
    // {
    //   name: "lglWhs",
    //   selector: (row) => row?.lglWhs || "--",
    //   sortable: true,
    //   width: "100px",
    // },
    {
      name: "Qlt",
      selector: (row) => row?.quality || "--",
      sortable: true,
      width: "100px",
    },
    // {
    //   name: "Lot",
    //   selector: (row) => row?.lot || "--",
    //   sortable: true,
    //   width: "100px",
    // },
    // {
    //   name: "Cnr IT",
    //   selector: (row) => row?.cnrIt || "--",
    //   sortable: true,
    //   width: "100px",
    // },
    // {
    //   name: "Cnr",
    //   selector: (row) => row?.cnr || "--",
    //   sortable: true,
    //   width: "130px",
    // },
    // {
    //   name: "Cnr Element",
    //   selector: (row) => row?.containerElement || "--",
    //   sortable: true,
    //   width: "140px",
    // },
    // {
    //   name: "Cnr Element",
    //   selector: (row) => row?.containerElement || "--",
    //   sortable: true,
    //   width: "140px",
    // },
    // {
    //   name: "Base Pri Qty",
    //   selector: (row) => row?.baseprimaryquantity || "--",
    //   sortable: true,
    //   width: "140px",
    // },
    // {
    //   name: "Colour",
    //   selector: (row) => row.perBagBox || "--",
    //   cell: (row) => (
    //     <div>
    //       {/* Color Rectangle */}
    //       {row?.colour && (
    //         <>
    //           <div
    //             style={{
    //               width: "60px",
    //               height: "20px",
    //               backgroundColor: row.colour,
    //               border: "1px solid #ccc",
    //               borderRadius: "3px",
    //               marginTop: "5px",
    //             }}
    //           >
    //             {" "}
    //           </div>
    //           <p className="m-0 p-0">{row?.colour}</p>
    //         </>
    //       )}
    //     </div>
    //   ),
    //   sortable: true,
    //   width: "130px",
    // },
    // {
    //   name: "Per Bag/Box",
    //   selector: (row) => row.perBagBox || "--",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0  fw-bold text-primary">{row?.perBagBox} </p>
    //       <p className="m-0 p-0 pt-1  ">{row?.unitIn} </p>
    //     </div>
    //   ),
    //   sortable: true,
    //   width: "130px",
    // },
    {
      name: "CGST%",
      selector: (row) => row.cgst || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "SGST%",
      selector: (row) => row.sgst || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "Attachments",
      selector: (row) => row.materialAttachments,
      cell: (row) => (
        <div
          style={{ width: "100%" }}
          className="d-flex justify-content-center cursor-pointer"
          // onClick={()=>showViewInvoice(row)}
          // onClick={() => handlePrintWithData(row)}
        >
          <img
            src="assets/img/newIcons/attached-file.png"
            alt="attachments"
            style={{ width: "25px" }}
            className="mt-1"
          />
        </div>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Active",
      selector: (row) => row.activeInactive,
      cell: (row) => (
        <div className="form-check form-switch">
          <input
            className="form-check-input custom-switch"
            type="checkbox"
            role="switch"
            id={`switch-${row.local_id}`}
            checked={row.activeInactive === true}
            // onChange={(event) => handleCheckboxChange(row.local_id, event)}
          />
        </div>
      ),
      sortable: true,
      width: "130px",
    },
  ];
  const handleSearchFuncApi = () => {
    const search = getCommonSearchTxt.trim().toLowerCase();

    if (search === "") {
      setFilteredData(data); // show all when empty
      return;
    }

    const result = data.filter((item) =>
      searchableKeys.some((key) =>
        String(item[key] || "")
          .toLowerCase()
          .includes(search),
      ),
    );

    setFilteredData(result);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      handleSearchFuncApi();
    }, 300);

    return () => clearTimeout(timeout);
    // eslint-disable-next-line
  }, [getCommonSearchTxt]);

  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      dialogClassName="modal-90w"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Material Selection
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        <form className="space-y-4">
          <Row>
            <Col
              sm={{ offset: 6, span: 6 }}
              md={{ offset: 8, span: 4 }}
              lg={{ offset: 8, span: 4 }}
              className="commLeftRightPadding"
            >
              {/*  <SearchField
                name="searchKey"
                value={getCommonSearchTxt}
                onChange={(event) => setCommonSearchTxt(event.target.value)}
                onClick={undefined}
                // onClick={handleSearchFuncApi}
              /> */}
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={12} lg={12} className="commLeftRightPadding">
              <div className="accordion" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={() => toggleCardVisibility()}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">CS</span>
                      </Col>
                      <Col xs={12} md={9} lg={9}>
                        <span className="headerTitle">Material Selection</span>
                        <span className="subHeaderTitle">
                          View of Material Selection{" "}
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${
                      isCardVisible ? "visible" : ""
                    }`}
                    // aria-labelledby="headingOne"
                    // data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            title=""
                            columns={columns}
                            // data={data}
                            // data={filteredData}
                            data={materialData}
                            progressPending={loading}
                            paginationRowsPerPageOptions={
                              SupplierConstants.ROW_PER_PAGE
                            }
                            pagination
                            // paginationServer
                            // paginationTotalRows={totalRows}
                            // onChangeRowsPerPage={handlePerRowsChange}
                            // onChangePage={handlePageChange}
                            selectableRows
                            onSelectedRowsChange={handleChangeCat}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          <Row className="justify-end">
            <Col xs={6} md={2} lg={2} className="commLeftRightPadding">
              <button
                type="button"
                onClick={() => props.onHide()}
                className="btn btn-danger mt-4 w-full justify-center rounded-md"
              >
                Cancel
              </button>
            </Col>
            <Col xs={6} md={2} lg={2} className="commLeftRightPadding">
              <button
                type="button"
                onClick={handleSubmit}
                className="btn btn-primary mt-4 w-full justify-center rounded-md"
                disabled={disabled}
              >
                Select
              </button>
            </Col>
            {/* <Col xs={12} md={12} lg={12} className="commLeftRightPadding">
              <p className="errorMsg"> {errorMsg} </p>
            </Col> */}
          </Row>
        </form>
      </Modal.Body>
    </Modal>
  );
});

export default MaterialSelectionModal;
